import { render, staticRenderFns } from "./IconCogFilled.vue?vue&type=template&id=b5315fd0&"
import script from "./IconCogFilled.vue?vue&type=script&lang=js&"
export * from "./IconCogFilled.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports